<template>
  <el-form label-width="100px">
    <el-form-item label="快捷短语：">
      <el-input
        :value="keyword"
        @input="quickChange"
        placeholder="请输入快捷短语"
      ></el-input>
    </el-form-item>
  </el-form>
</template>

<script>
  export default {
    props: {
      keyword: String,
    },
    methods: {
      quickChange(e) {
        this.$emit('quickChange', e)
      },
    },
  }
</script>

<style lang="scss" scoped></style>
